import { render } from "./MorePayment.vue?vue&type=template&id=53223063&scoped=true"
import script from "./MorePayment.vue?vue&type=script&lang=js"
export * from "./MorePayment.vue?vue&type=script&lang=js"

import "./MorePayment.vue?vue&type=style&index=0&id=53223063&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53223063"]])

export default __exports__